import { CurrencyCode, currencyMap } from '@percent/utility';

export type MoneyInputValue = { amount?: number | null; currency: CurrencyCode } | undefined;

export type MoneyUpdate =
  | { kind: 'clear' }
  | { kind: 'currency-only'; currency: CurrencyCode }
  | { kind: 'ignore' }
  | { kind: 'commit'; amountMinor: number; currency: CurrencyCode };

const decimalCount = (raw: string | undefined): number => {
  if (!raw) return 0;
  const dotIdx = raw.indexOf('.');
  if (dotIdx === -1) return 0;
  return raw.length - dotIdx - 1;
};

export const computeMoneyUpdate = (value: MoneyInputValue, raw: string | undefined): MoneyUpdate => {
  if (!value) return { kind: 'clear' };

  const { currency } = value;
  if (value.amount === undefined || value.amount === null) {
    return { kind: 'currency-only', currency };
  }

  const minorUnits = currencyMap[currency]?.minorUnits ?? 2;
  if (decimalCount(raw) > minorUnits) {
    return { kind: 'ignore' };
  }

  return { kind: 'commit', amountMinor: value.amount, currency };
};
